import { render } from "./ConInsView.vue?vue&type=template&id=4254d424"
import script from "./ConInsView.vue?vue&type=script&lang=js"
export * from "./ConInsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__